import t from"react";var e=function(e){var r=e.children;return t.createElement("div",{className:"ptw-ml-3 ptw-text-body-sm ptw-text-surface-textSubdued"},r)};export{e as default};
//# sourceMappingURL=FormSubscript.js.map
